(function () {

	if (typeof Prism === 'undefined') {
		return;
	}

	Prism.hooks.add('wrap', function (env) {
		if (env.type !== 'keyword') {
			return;
		}
		env.classes.push('keyword-' + env.content);
	});

}());



// WEBPACK FOOTER //
// ./node_modules/prismjs/plugins/highlight-keywords/prism-highlight-keywords.js